<template>
    <div class="pc-footer">
        <div class="container">
            <div class="footer-links">
                <el-link type="text" @click="showModel(1)">会员须知</el-link>
                <el-link type="text" @click="$router.push('/news?type=1')">市场动态</el-link>
                <el-link type="text" @click="$router.push('/news?type=2')">通知公告</el-link>
                <el-link type="text" @click="showModel(2)">关于我们</el-link>
            </div>
            <div class="copyright">
                © Copyrights {{ Year }} {{ systemInfo.copyright ? systemInfo.copyright.web_name : '' }} All rights Reserved. <a class="bottom_beian_url" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{{ systemInfo.copyright ? systemInfo.copyright.web_site_icp : '' }}</a> <a class="bottom_beian_url" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + recordNumber()" target="_blank" rel="noopener noreferrer"><img src="@/static/imgs/jinggongwanganbei.png" :alt="systemInfo.copyright ? systemInfo.copyright.web_site_ga_icp : ''"> {{ systemInfo.copyright ? systemInfo.copyright.web_site_ga_icp : '' }}</a>
            </div>
            <div class="copyright">
                <span v-if="systemInfo.copyright && systemInfo.copyright.operating_entity ? true : false">版权所有：{{ systemInfo.copyright ? systemInfo.copyright.operating_entity : '' }} &nbsp;&nbsp;&nbsp;&nbsp; </span>技术支持：<a class="bottom_beian_url" :href="systemInfo.copyright ? systemInfo.copyright.technical_support_url : ''" target="_blank" rel="noopener noreferrer">{{ systemInfo.copyright ? systemInfo.copyright.technical_support : '' }}</a>
            </div>
        </div>
        <el-dialog 
            title="" 
            :visible.sync="showModal" 
            width="780px"
            :close-on-click-modal="false"
            destroy-on-close
            class="custom-member-rule-modal"
        >
            <!-- 自定义弹窗头部 -->
            <div class="member-rule-header">
                <i class="member-rule-icon" :class="modeltype == 1 ? 'el-icon-user-solid' : 'el-icon-connection'"></i>
                <span class="member-rule-title">{{ modeltype == 1 ? '会员须知' : '关于我们' }}</span>
                <el-divider direction="horizontal" class="member-rule-divider"></el-divider>
            </div>
            <div class="scoolbox" v-html="modeltype == 1 ? systemInfo.system_info ? systemInfo.system_info.buy_info : '' : systemInfo.system_info ? systemInfo.system_info.about_us : ''"></div>
        </el-dialog>
    </div>
</template>

<script>
import { Session } from '@/utils/storage';
export default {
    name: 'FooterPc',
    data() {
        return {
            systemInfo: {},
            Year: '',
            showModal: false,
            modeltype: 1
        };
    },
    mounted() {
        // 初始化获取Session数据
        this.systemInfo = Session.get('systemConfig') || {};
        console.log(this.systemInfo);
        this.Year = new Date().getFullYear();
    },
    methods: {
        recordNumber(){
            return this.systemInfo.copyright ? (this.systemInfo.copyright.web_site_ga_icp.match(/\d/g)?.join('') || '') : '';
        },
        showModel(type){
            if(type == 1){
                this.modeltype = 1;
            }else if(type == 2){
                this.modeltype = 2;
            }
            this.showModal = true;
        }
    }
};
</script>

<style scoped>
    .pc-footer {
        background-color: #f5f5f5;
        padding: 20px 0;
        border-top: 1px solid #eee;
    }
    .container {
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .footer-links {
        margin-bottom: 10px;
    }
    .footer-links .el-link {
        margin: 0 10px;
        font-size: 14px;
        color: #666;
    }
    .copyright {
        font-size: 12px;
        color: #999;
    }
    .bottom_beian_url{
        color: #999 !important;
        text-decoration: none !important;
    }
    .bottom_beian_url:hover{ 
        text-decoration: underline !important;
    }

    .footer-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 50px;
        border-top: 1px solid #e5e7eb;
        background: #f8fafc;
    }
    .footer-left {
        color: #666;
        font-size: 12px;
    }
    .footer-left p {
        margin: 0 0 5px 0;
    }
    .footer-right {
        display: flex;
        gap: 20px;
    }
    .footer-right .el-button {
        color: #1890ff;
    }
    .scoolbox{
        max-height: 500px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    /* 弹窗头部 */
    .member-rule-header {
        text-align: center;
    }
    .member-rule-icon {
        font-size: 30px;
        color: #1890ff;
        margin-right: 10px;
    }
    .member-rule-title {
        font-size: 24px;
        font-weight: 600;
        color: #1f2937;
        letter-spacing: 1px;
    }
    .member-rule-divider {
        margin: 0 30px 20px 30px;
        background: #f5f7fa;
    }

</style>